import { fetcher } from '@commenda/utils';
import { CreateSecureInformationRequestArgs } from './types';

export async function createSecureInformationRequest(
  body: CreateSecureInformationRequestArgs,
  token: string
) {
  const response = await fetcher(
    `secureInformationRequest/`,
    {
      method: 'POST',
      body,
    },
    token
  );

  return response;
}
